import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const newPostBadge = style([
  typography.bodySm,
  {
    width: 'fit-content',
    height: 'fit-content',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    top: 1,
    fontSize: 9,
    color: themeVars.container.foreground.brand,
    backgroundColor: themeVars.container.prominent.background.idle,
    borderRadius: borderRadius.r16,
    padding: `${space.s1}px ${space.s12}px`,
    textTransform: 'uppercase',
    zIndex: 1,
    transition: 'opacity .2s, visibility .2s',
    opacity: 1,
    visibility: 'visible',

    selectors: {
      '&[data-hidden]': {
        opacity: 0,
        visibility: 'hidden',
      },
    },
  },
]);
